"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentOrigin = void 0;
var PaymentOrigin;
(function (PaymentOrigin) {
    PaymentOrigin["BLOCKCHAIN"] = "BLOCKCHAIN";
    PaymentOrigin["INTERNAL"] = "INTERNAL";
    PaymentOrigin["MANUAL"] = "MANUAL";
})(PaymentOrigin = exports.PaymentOrigin || (exports.PaymentOrigin = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGF5bWVudE9yaWdpbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9QYXltZW50T3JpZ2luLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksYUFJWDtBQUpELFdBQVksYUFBYTtJQUN2QiwwQ0FBMkIsQ0FBQTtJQUMzQixzQ0FBdUIsQ0FBQTtJQUN2QixrQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsYUFBYSxHQUFiLHFCQUFhLEtBQWIscUJBQWEsUUFJeEIifQ==